// extracted by mini-css-extract-plugin
module.exports = {"firstColumn":"ProviderContacts_firstColumn__iG26Z","secondColumn":"ProviderContacts_secondColumn__frhPj"};